import { GridPinnedColumnFields } from "@mui/x-data-grid-premium";
import { GroupingField } from "../../../../api/biClient.types.ts";
import {
  getRowGroupingFieldsInMultipleRowGroupingColumnMode,
  getRowGroupingFieldsInSingleRowGroupingColumnMode,
  separateFrozenColumns,
} from "./groupedColumnsHelper.ts";

export const handlePinnedColumnsChange = (
  newFrozenColumnsModel: GridPinnedColumnFields,
  oldFrozenColumnIds: string[] | undefined,
  groups: GroupingField[],
  showGroupedColumns: boolean
): string[] => {
  if (!groups.length) {
    return newFrozenColumnsModel.left ?? [];
  }

  if (!newFrozenColumnsModel.left || newFrozenColumnsModel.left.length === 0) {
    return [];
  }

  const { nonGroupedFrozenColumns } = separateFrozenColumns(newFrozenColumnsModel.left);

  const groupedFields = showGroupedColumns
    ? getRowGroupingFieldsInMultipleRowGroupingColumnMode(groups)
    : getRowGroupingFieldsInSingleRowGroupingColumnMode(groups);

  const deletedFreezedColumn = oldFrozenColumnIds?.filter((column) => !newFrozenColumnsModel.left?.includes(column))[0];

  if (deletedFreezedColumn && groupedFields.includes(deletedFreezedColumn)) {
    return [];
  }

  return [...groupedFields, ...nonGroupedFrozenColumns];
};
